import type { Chat } from './api'
import { isFreeChat } from './chatListFilters'

function normalizeTitle(value: string | null | undefined): string {
  const title = (value || '').trim().replace(/\s+/g, ' ')
  return title || 'New topic'
}

export function nextForkTopicTitle(
  currentTitle: string | null | undefined,
  existingTitles: Array<string | null | undefined>,
): string {
  const title = normalizeTitle(currentTitle)
  const match = title.match(/^(.*?)(?:\s+(\d+))?$/)
  const base = normalizeTitle(match?.[1] || title)
  let next = match?.[2] ? Number.parseInt(match[2], 10) + 1 : 2
  if (!Number.isFinite(next) || next < 2) next = 2

  const used = new Set(
    existingTitles
      .map(normalizeTitle)
      .map((value) => value.toLocaleLowerCase()),
  )
  while (used.has(`${base} ${next}`.toLocaleLowerCase())) {
    next += 1
  }
  return `${base} ${next}`
}

export function forkableLaneTargets(chats: Chat[] | undefined, sourceChatId: string): Chat[] {
  return (chats || [])
    .filter((chat) => chat.id !== sourceChatId)
    .filter((chat) => isFreeChat(chat))
}
